import {
  useFetchQuoteMessage,
  useUpdateQuoteMessage,
} from "@/lib/queries/hooks";
import { useRef, useState } from "react";

export default function Message({
  quoteRevisionId,
  disabled = false,
  defaultEmailBody,
}: {
  quoteRevisionId: string;
  disabled?: boolean;
  defaultEmailBody: string;
}) {
  const initialMessage = useFetchQuoteMessage()?.body || defaultEmailBody;
  const [input, setInput] = useState<string>();
  const timeoutRef = useRef<number>();
  const { updateQuoteMessage } = useUpdateQuoteMessage({});

  return (
    <textarea
      disabled={disabled}
      placeholder="Email Body"
      className="p-2 border rounded-sm"
      rows={10}
      value={input ?? initialMessage}
      onChange={(e) => {
        const value = e.target.value;
        setInput(value);
        clearTimeout(timeoutRef.current);
        timeoutRef.current = setTimeout(
          () =>
            updateQuoteMessage({
              quoteRevisionId,
              message: value,
            }),
          1000,
        );
      }}
    />
  );
}
